/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import clsx from 'clsx';
import { Box } from '@material-ui/core/';
import { useStyles } from './style';

interface BadgeProps {
  outLined: boolean;
  variant: BadgeVariant;
  size: BadgeSize;
  text: string;
  testId: string;
}

export enum BadgeVariant {
  SUCCESS = 'success',
  WARNING = 'warning',
  LIGHT = 'light',
  ERROR = 'error',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum BadgeSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export function Badge(props: BadgeProps) {
  const { size, variant, outLined, text, testId } = props;
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.defaultBadge, {
        [classes.successBadge]: !outLined && variant === BadgeVariant.SUCCESS,
        [classes.successBadgeOutlined]:
          outLined && variant === BadgeVariant.SUCCESS,
        [classes.warningBadge]: !outLined && variant === BadgeVariant.WARNING,
        [classes.warningBadgeOutlined]:
          outLined && variant === BadgeVariant.WARNING,
        [classes.lightBadge]: !outLined && variant === BadgeVariant.LIGHT,
        [classes.lightBadgeOutlined]:
          outLined && variant === BadgeVariant.LIGHT,
        [classes.errorBadge]: !outLined && variant === BadgeVariant.ERROR,
        [classes.errorBadgeOutlined]:
          outLined && variant === BadgeVariant.ERROR,
        [classes.primaryBadge]: !outLined && variant === BadgeVariant.PRIMARY,
        [classes.primaryBadgeOutlined]:
          outLined && variant === BadgeVariant.PRIMARY,
        [classes.secondaryBadge]:
          !outLined && variant === BadgeVariant.SECONDARY,
        [classes.secondaryBadgeOutlined]:
          outLined && variant === BadgeVariant.SECONDARY,
        [classes.smallBadge]: size === BadgeSize.SMALL,
        [classes.mediumBadge]: size === BadgeSize.MEDIUM,
        [classes.largeBadge]: size === BadgeSize.LARGE,
      })}
      data-testid={testId}
    >
      {text}
    </Box>
  );
}

export default Badge;
